import { apiWithBody, apiWithQuery, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_Organization, DBDef_Organization, OrganizationCollectionKeyMapper, OrganizationManagerKeysMapper } from '@app/org-shared';
import { PermissionKey_FE } from '@nu-art/permissions-frontend/PermissionKey_FE';
export const dispatch_onOrganizationChanged = new ThunderDispatcherV3('__onOrganizationUpdated');
export class ModuleFE_Organization_Class extends ModuleFE_BaseApi {
    permissions;
    _v1;
    __searchFilterMapper = (item) => [item.name];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => ({ _id: i._id, uiLabel: i.name }))
        }]);
    constructor() {
        super(DBDef_Organization, dispatch_onOrganizationChanged);
        // set permission FE keys objects
        this.permissions = {
            ui: PermissionKey_FE.generatePermissionKeysByLevels(OrganizationManagerKeysMapper),
            collection: PermissionKey_FE.generatePermissionKeysByLevels(OrganizationCollectionKeyMapper)
        };
        this._v1 = {
            getAllowedOrganizationIds: apiWithQuery(ApiDef_Organization._v1.getAllowedOrganizationIds),
            deleteOrganization: apiWithBody(ApiDef_Organization._v1.deleteOrganization),
        };
    }
    getOrganizationByEmail = (email) => {
        const emailDomain = email.substring(email.indexOf('@') + 1).toLowerCase();
        try {
            return this.cache.find(organization => organization.webDomains.includes(emailDomain));
        }
        catch (e) {
            this.logErrorBold(`Failed finding organization by email with domain '${emailDomain}'.`);
        }
    };
}
export const ModuleFE_Organization = new ModuleFE_Organization_Class();
//# sourceMappingURL=ModuleFE_Organization.js.map